export const GET_SCHEDULE_DATE = Symbol('GET_SCHEDULE_DATE');
export const GET_SCHEDULE_DATE_REQUEST = Symbol('GET_SCHEDULE_DATE_REQUEST');
export const GET_SCHEDULE_DATE_SUCCESS = Symbol('GET_SCHEDULE_DATE_SUCCESS');
export const GET_SCHEDULE_DATE_ERROR = Symbol('GET_SCHEDULE_DATE_ERROR');

